import { render, staticRenderFns } from "./PageNotFound.vue?vue&type=template&id=15e1c0d8&"
var script = {}
import style0 from "./PageNotFound.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "PageNotFound.vue"
export default component.exports